<div class="article-tpye-base-article-definition-list">
  <sc-padding>
    <table class="table">
      @for (attribute of definition?.attributes; track attribute; let i = $index) {
        <tr>
          <td class="text-selection">{{i+1}}</td>
          <td class="text-selection"><app-dictionary-entry-label [model]="attribute?.articleTypeAttribute?.name"></app-dictionary-entry-label></td>
        </tr>
      }
    </table>
  </sc-padding>
</div>
